import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { REASON_CODES } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from '../models/ColumnDefinitions/ReasonCodeColumns';
import { Filter } from "../models/Filter";
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/ReasonCodeSearch';
import SiteSearch from "../models/search/SiteSearch";
import { getReasonCodes } from "../services/reasonCodeService";
import { getSiteNamesWithPagination } from "../services/siteService";
import { DEF_PG_SIZE_LIST_WO_ADD } from '../constants/maximum-page-size';
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";

interface Props {
    onFilterChange: (filters: Filter[]) => void;
}

const ReasonCodesTab: FC<Props> = ({onFilterChange}) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.reasonCodes);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/hardware/reason-code/';

    useEffect(() => {
        setLookup([{
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        }]);
    }, [])
    // --> start context
    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REASON_CODES;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }
    // <-- end context

    return (
        <TableContextProvider
            initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
            dataMethod={getReasonCodes}
            tableDescriptor={columns}
            searchDescriptor={searchColumns}
            useFilter
            useSort
            usePagination
            useSearch
            useTable
            maxPageSize={DEF_PG_SIZE_LIST_WO_ADD}
            lookup={lookup}
            showAddNewButton={false}>
            <TableContextStateMonitor onFilterChange={onFilterChange} />
            <TableTab
                title={title}
                selectRows={false}
                rowPath={itemPath}
                cyName="reasonCodes"
            />
        </TableContextProvider>
    );
};

export default ReasonCodesTab;
